import { render, staticRenderFns } from "./CreateRegion.vue?vue&type=template&id=82223146"
import script from "./CreateRegion.vue?vue&type=script&lang=js"
export * from "./CreateRegion.vue?vue&type=script&lang=js"
import style0 from "./CreateRegion.vue?vue&type=style&index=0&id=82223146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports